<template>
    <div>
        <vs-row>
            <vs-col vs-w="6">
                <vs-button
                    v-if="currentStep > 0"
                    id="prev2"
                    class="mr-2"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                    @click.native="prevClickHandle"
                >
                    Précédent
                </vs-button>

                <vs-button
                    id="goBack"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-arrow-left"
                    :href="''"
                >
                    Sortir
                </vs-button>
            </vs-col>
            <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
                <vs-button
                    v-if="!isLastStep"
                    id="next2"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    @click.native="nextClickHandle"
                >
                    Suivant
                </vs-button>
                <vs-button
                    v-else
                    id="submit2"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-check"
                    @click="nextClickHandle"
                >
                    Retour
                </vs-button>
            </vs-col>
        </vs-row>
        <div class="mt-3">
            <form-wizard
                ref="formWizard"
                color="rgba(var(--vs-primary), 1)"
                error-color="rgba(var(--vs-danger), 1)"
                :start-index="currentStep"
                :subtitle="null"
                @on-complete="endFormHandle"
                @on-validate="validateFormHandle"
                @on-error="errorFormHandle"
                @on-change="changePageHandle"
            >
                <h4 slot="title" class="wizard-custom-title">
                    Campagne {{ resource.campaignType }} "{{ resource.campaignTitle }}" - {{ titleStartDate }} au {{ titleEndDate }}
                </h4>

                <!-- Alerte erreur de validation -->
                <div v-if="errorValidateMessage" class="mb-10">
                    <vs-alert color="danger" active="true">
                        {{ errorValidateMessage }}
                    </vs-alert>
                </div>

                <!-- Tab: Périmètre -->
                <tab-content
                    title="Périmètre"
                    class="mb-5"
                    icon="feather icon-crosshair"
                    :before-change="validatePerimeter"
                >
                    <form :data-vv-scope="`step-${getStepFromName('perimeter')}`">
                        <Perimeter-Tab
                            v-model="resource"
                        ></Perimeter-Tab>
                    </form>
                </tab-content>

                <!-- Tab: Synthese V0 -->
                <tab-content
                    title="Synthèse V0"
                    class="mb-5"
                    icon="feather icon-crosshair"
                    :before-change="validatePerimeter"
                >
                    <form :data-vv-scope="`step-${getStepFromName('synthese-v0')}`">
                        <Synthese-V0-Tab
                            v-model="resource"
                        ></Synthese-V0-Tab>
                    </form>
                </tab-content>

                <!-- Tab: Souhaits d'évolution et objectifs-->
                <tab-content
                    title="Synthèse V1"
                    class="mb-5"
                    icon="feather icon-briefcase"
                    :before-change="validateGoalsAndSynthesis"
                >
                    <form :data-vv-scope="`step-${getStepFromName('synthese-v1')}`">
                        <Synthese-V1-Tab
                            v-model="resource"
                        ></Synthese-V1-Tab>
                    </form>
                </tab-content>

                <!-- Actions -->
                <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left" onclick="window.scrollTo(0,0)">
                        <vs-button
                            v-if="props.activeTabIndex > 0"
                            id="prev"
                            color="primary"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-chevron-left"
                            @click.native="prevClickHandle"
                        >
                            Précédent
                        </vs-button>
                    </div>

                    <div class="wizard-footer-right" onclick="window.scrollTo(0,0)">
                        <vs-button
                            v-if="!props.isLastStep"
                            id="next"
                            class="wizard-footer-right"
                            color="primary"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-chevron-right"
                            @click.native="nextClickHandle"
                        >
                            Suivant
                        </vs-button>
                        <vs-button
                            v-else
                            id="submit"
                            class="wizard-footer-right finish-button"
                            color="primary"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-check"
                            @click.native="nextClickHandle"
                        >
                            Retour
                        </vs-button>
                    </div>
                </template>

            </form-wizard>
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import PerimeterTab from './partials/tabs/PerimeterTab.vue';
import SyntheseV0Tab from './partials/tabs/SyntheseV0Tab.vue';
import SyntheseV1Tab from './partials/tabs/SyntheseV1Tab.vue';

import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
    components: {
        FormWizard,
        TabContent,
        PerimeterTab, SyntheseV1Tab, SyntheseV0Tab
    },
    props: {
        campaign: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            init: true,
            log: console.log,
            currentStep: 0,
            maxStep: 0,
            lastStep: 0,
            errorValidateMessage: null,
            resource: {},
            targetDebugStep: 0, // DEV - Utilisé pour le DEBUG
        };
    },

    created() {
        let start = Date.now()
        this.initResource(false);

        // --> Utilisé pour le débug
        if (this.targetDebugStep && this.targetDebugStep > 1) {
            setTimeout(() => {
                document.getElementById('next').click();
            }, 1500);
        }
    },

    mounted() {
        this.lastStep = this.$refs.formWizard.tabCount - 1;
    },

    updated() {

    },
    computed: {
        isLastStep() {
            return this.currentStep === this.lastStep;
        },
        titleStartDate() {
            return this.$moment(this.resource.campaignStartDate).format("l");
        },
        titleEndDate() {
            return this.$moment(this.resource.campaignEndDate).format("l");
        },
    },
    watch: {
        resource: {
            handler: function(value) {
                console.log('Watch Global Resource', value)
            },
            deep: true
        },
    },
    methods: {

        initResource(fake = false) {
            this.resource = window._.cloneDeep(this.campaign);
            console.log('Resource', this.resource)

            //Fake
            if (fake) {
                this.resource.campaignType = "Evaluation des enseignements et des formations";
                this.resource.campaignTitle = "EEE Mathématiques"
                this.resource.campaignStartDate = "15/11/2025"
                this.resource.campaignEndDate = "15/02/2026"
            }

            //Real
            else {
                this.resource.campaignType = this.campaign?.type?.name || 'Type';
                this.resource.campaignTitle = this.campaign?.title || 'Titre';
                this.resource.campaignStartDate = this.campaign?.start_date || '../../....';
                this.resource.campaignEndDate = this.campaign?.end_date || '../../....';
            }
        },

        changePageHandle(prevIndex, nextIndex) {

            this.currentStep = nextIndex;

            if (this.maxStep < nextIndex) {
                this.maxStep = nextIndex;
            }

            // Utilisé pour le débug
            if (this.targetDebugStep && this.targetDebugStep > nextIndex) {
                setTimeout(() => {
                    this.$refs.formWizard.nextTab();
                }, 1500);
            }
        },

        /**
         * Evénement à la fin du formulaire
         */
        endFormHandle() {
            this.redirectBack();
        },

        redirectBack() {
            document.location.href = this.backUrl
        },

        validateFormHandle(isValid, tabIndex) {
            this.errorValidateMessage = null;
        },

        errorFormHandle(errorValidateMessage) {
            this.errorValidateMessage = errorValidateMessage;
        },

        validatePerimeter() {
            return true
        },

        validateGoalsAndSynthesis() {
            return true
        },

        getStepFromName(name) {
            let step = 0;

            switch (name) {
                case 'perimeter':
                    step = 0;
                    break;
                case 'synthese-v0':
                    step = 1;
                    break;
                case 'synthese-v1':
                    step = 2;
                    break;
            }

            return step;
        },

        prevClickHandle() {
            this.$refs.formWizard.prevTab();
        },

        nextClickHandle() {
            this.$refs.formWizard.nextTab();
        }
    }
};
</script>

<style lang="scss" scoped>
form {
    padding-top: 1.5em;
}
.switch {
    margin-bottom: -2rem;
}
.bold {
    font-weight: bold;
}
.prefilled {
    background-color: #fafafa;
    border-bottom: 1px solid white;
    p i {
        color: #727272;
    }
}

::v-deep .vue-form-wizard {
    .wizard-title {
        font-weight: bold !important;
    }
    .wizard-custom-title {
        color: #252422;
    }

    // Onglet désactivé
    .disabled-tab {
        pointer-events: none;
        .stepTitle, a {
            color: #cbcbcb !important;
            user-select: none;
        }
        .wizard-icon-circle {
            border: 3px solid #f1f1f1 !important;
            user-select: none;
            i {
                color: #e9e9e9;
            }
        }
    }
}

#saveQuit {
    top: 305px;
    position: fixed; right: 56px;
    z-index: 99999
}

#goBack {
    margin-right: 135px;
}

// Modification de la position du bouton suivant pour DEV
// #next {
//     position: absolute;
//     right: 32px;
//     top: 50px;
// }
</style>

his